(function () {
  if (window.HfCarousel) return;

  function HfCarousel(rootEl, options) {
    var track = rootEl.querySelector('.hf-carousel__track') || rootEl;
    var list = track.querySelector('.hf-carousel__list') || track.firstElementChild;
    if (!track || !list) return null;

    var originals = Array.prototype.filter.call(list.children, function (c) {
      return c.tagName !== 'SCRIPT' && c.tagName !== 'STYLE' && c.tagName !== 'LINK';
    });
    var n = originals.length;
    if (!n) return null;

    options = options || {};
    var fade = !!options.fade;
    var loop = !!options.loop && n > 1;
    var align = options.align || 'start';
    var duration = options.duration || 400;
    var watchDrag = !fade && options.watchDrag !== false;
    var wrapDrag = !!options.wrapDrag;
    var startIndex = ((options.startIndex || 0) % n + n) % n;
    var perView = options.perView || 1;
    var cloneCount = 0;
    if (loop && !fade) {
      cloneCount = Math.min(n, Math.max(2, Math.ceil(perView)));
    }

    var slides = originals.slice();
    var slideWidths = [];
    var trackW = 0;
    var gap = 0;

    var logicalActive = startIndex;
    var position = 0;

    var isDragging = false;
    var dragStartX = 0;
    var dragStartPos = 0;
    var dragLastX = 0;
    var dragLastTime = 0;
    var dragVelocity = 0;
    var dragMoved = false;
    var pointerId = null;

    var animTimer = null;
    var listeners = {};

    function emit(name) {
      var fns = listeners[name];
      if (!fns) return;
      for (var i = 0; i < fns.length; i++) {
        try { fns[i](); } catch (e) {}
      }
    }
    function on(name, fn) { (listeners[name] = listeners[name] || []).push(fn); }

    originals.forEach(function (s, i) { s.dataset.hfLogicalIdx = String(i); });

    if (cloneCount > 0) {
      for (var i = 0; i < cloneCount; i++) {
        var srcIdxStart = ((n - cloneCount + i) % n + n) % n;
        var clone = originals[srcIdxStart].cloneNode(true);
        clone.classList.add('hf-clone', 'hf-carousel__slide--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.hfLogicalIdx = String(srcIdxStart);
        list.insertBefore(clone, originals[0]);
      }
      for (var j = 0; j < cloneCount; j++) {
        var srcIdxEnd = j % n;
        var clone2 = originals[srcIdxEnd].cloneNode(true);
        clone2.classList.add('hf-clone', 'hf-carousel__slide--clone');
        clone2.setAttribute('aria-hidden', 'true');
        clone2.dataset.hfLogicalIdx = String(srcIdxEnd);
        list.appendChild(clone2);
      }
      slides = Array.prototype.filter.call(list.children, function (c) {
        return c.tagName !== 'SCRIPT' && c.tagName !== 'STYLE' && c.tagName !== 'LINK';
      });
    }
    var totalSlides = slides.length;
    var currentDomIdx = cloneCount + startIndex;

    function logicalToDom(logical) {
      return cloneCount + ((logical % n) + n) % n;
    }

    function domToLogical(domIdx) {
      var s = slides[domIdx];
      if (!s) return 0;
      return parseInt(s.dataset.hfLogicalIdx, 10);
    }

    function measure() {
      trackW = track.clientWidth;
      var listStyle = window.getComputedStyle(list);
      gap = parseFloat(listStyle.gap || listStyle.columnGap || '0') || 0;
      slideWidths = [];
      for (var i = 0; i < totalSlides; i++) slideWidths.push(slides[i].offsetWidth);
    }

    function getSlideX(domIdx) {
      var x = 0;
      for (var i = 0; i < domIdx; i++) x += slideWidths[i] + gap;
      return x;
    }

    function snapPositionFor(domIdx) {
      var x = getSlideX(domIdx);
      if (align === 'center') {
        return -(x + slideWidths[domIdx] / 2 - trackW / 2);
      }
      return -x;
    }

    function setTransform(noAnim) {
      list.style.transition = noAnim ? 'none' : 'transform ' + duration + 'ms cubic-bezier(0, 0, 0.3, 1)';
      list.style.transform = 'translate3d(' + position + 'px, 0, 0)';
    }

    function applyFadeState(noAnim) {
      slides.forEach(function (s) {
        var lIdx = parseInt(s.dataset.hfLogicalIdx, 10);
        var isActive = lIdx === logicalActive;
        s.style.transition = noAnim ? 'none' : 'opacity ' + duration + 'ms ease';
        s.style.opacity = isActive ? '1' : '0';
        s.style.zIndex = isActive ? '1' : '0';
        s.style.pointerEvents = isActive ? '' : 'none';
      });
    }

    function getCurrentVisualPosition() {
      var matrix = window.getComputedStyle(list).transform;
      if (!matrix || matrix === 'none') return position;
      var match = matrix.match(/matrix.*\(([^)]+)\)/);
      if (!match) return position;
      var values = match[1].split(', ');
      var v = values.length === 16 ? parseFloat(values[12]) : parseFloat(values[4]);
      return isNaN(v) ? position : v;
    }

    function loopStride() {
      var s = 0;
      for (var i = 0; i < n; i++) s += slideWidths[cloneCount + i] + gap;
      return s;
    }

    function applyActiveClass() {
      for (var i = 0; i < totalSlides; i++) {
        if (i === currentDomIdx) slides[i].classList.add('is-active');
        else slides[i].classList.remove('is-active');
      }
    }

    function normalizeDomIdx(useVisual) {
      if (cloneCount === 0) return;
      var changed = false;
      var visualPos = useVisual ? getCurrentVisualPosition() : position;
      var stride = loopStride();
      while (currentDomIdx >= cloneCount + n) {
        visualPos += stride;
        currentDomIdx -= n;
        changed = true;
      }
      while (currentDomIdx < cloneCount) {
        visualPos -= stride;
        currentDomIdx += n;
        changed = true;
      }
      if (changed) {
        position = visualPos;
        list.style.transition = 'none';
        list.style.transform = 'translate3d(' + visualPos + 'px, 0, 0)';
        void list.offsetWidth;
        applyActiveClass();
      }
    }

    function snapTo(targetLogical, noAnim, direction) {
      targetLogical = ((targetLogical % n) + n) % n;

      if (fade) {
        logicalActive = targetLogical;
        currentDomIdx = logicalToDom(targetLogical);
        applyFadeState(noAnim);
        applyActiveClass();
        emit('select');
        if (animTimer) { clearTimeout(animTimer); animTimer = null; }
        if (noAnim) emit('settle');
        else animTimer = setTimeout(function () { animTimer = null; emit('settle'); }, duration + 30);
        return;
      }

      if (!noAnim) normalizeDomIdx(true);

      var fromLogical = logicalActive;
      logicalActive = targetLogical;

      var fromDomIdx = currentDomIdx;
      var targetDomIdx;

      if (loop && cloneCount > 0 && !noAnim) {
        var diff = targetLogical - fromLogical;
        var fwd = ((diff % n) + n) % n;
        var bwd = (n - fwd) % n;
        if (direction === 1) {
          targetDomIdx = fromDomIdx + (fwd === 0 ? n : fwd);
        } else if (direction === -1) {
          targetDomIdx = fromDomIdx - (bwd === 0 ? n : bwd);
        } else if (fwd === 0 && bwd === 0) {
          targetDomIdx = fromDomIdx;
        } else if (fwd <= bwd) {
          targetDomIdx = fromDomIdx + fwd;
        } else {
          targetDomIdx = fromDomIdx - bwd;
        }
        if (targetDomIdx < 0) targetDomIdx = 0;
        if (targetDomIdx >= totalSlides) targetDomIdx = totalSlides - 1;
      } else {
        targetDomIdx = logicalToDom(targetLogical);
      }

      currentDomIdx = targetDomIdx;
      position = snapPositionFor(targetDomIdx);
      setTransform(noAnim);
      applyActiveClass();
      emit('select');

      if (animTimer) { clearTimeout(animTimer); animTimer = null; }
      var afterSettle = function () {
        animTimer = null;
        if (cloneCount > 0 && (currentDomIdx < cloneCount || currentDomIdx >= cloneCount + n)) {
          normalizeDomIdx(false);
        }
        emit('settle');
      };
      if (noAnim) afterSettle();
      else animTimer = setTimeout(afterSettle, duration + 30);
    }

    function detachDocListeners() {
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('pointercancel', onPointerCancel);
    }

    function resetDragState() {
      detachDocListeners();
      track.style.userSelect = '';
      track.style.webkitUserSelect = '';
      isDragging = false;
      dragMoved = false;
      pointerId = null;
    }

    function suppressNextClick() {
      var killClick = function (ev) {
        ev.stopImmediatePropagation();
        ev.preventDefault();
        window.removeEventListener('click', killClick, true);
      };
      window.addEventListener('click', killClick, true);
      setTimeout(function () {
        window.removeEventListener('click', killClick, true);
      }, 200);
    }

    function onPointerDown(e) {
      if (!watchDrag) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      resetDragState();
      pointerId = e.pointerId;
      isDragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartPos = position;
      dragLastX = e.clientX;
      dragLastTime = performance.now();
      dragVelocity = 0;
      track.style.userSelect = 'none';
      track.style.webkitUserSelect = 'none';
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
      document.addEventListener('pointercancel', onPointerCancel);
      emit('pointerDown');
    }

    function onPointerMove(e) {
      if (!isDragging || e.pointerId !== pointerId) return;
      var delta = e.clientX - dragStartX;
      if (Math.abs(delta) > 4 && !dragMoved) {
        dragMoved = true;
        list.style.transition = 'none';
        try { track.setPointerCapture(pointerId); } catch (_) {}
      }
      if (!dragMoved) return;
      if (e.cancelable) e.preventDefault();
      position = dragStartPos + delta;
      var now = performance.now();
      var dt = now - dragLastTime;
      if (dt > 0) dragVelocity = (e.clientX - dragLastX) / dt;
      dragLastX = e.clientX;
      dragLastTime = now;
      list.style.transform = 'translate3d(' + position + 'px, 0, 0)';
    }

    function onPointerUp(e) {
      if (!isDragging || e.pointerId !== pointerId) return;
      var moved = dragMoved;
      try { if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId); } catch (_) {}
      resetDragState();
      emit('pointerUp');

      if (!moved) return;

      suppressNextClick();

      var inertia = dragVelocity * 150;
      var projectedPos = position + inertia;

      var bestDomIdx = currentDomIdx;
      var bestDist = Infinity;
      for (var i = 0; i < totalSlides; i++) {
        var snap = snapPositionFor(i);
        var d = Math.abs(snap - projectedPos);
        if (d < bestDist) { bestDist = d; bestDomIdx = i; }
      }

      var posDelta = position - dragStartPos;
      var slideStep = Math.abs(snapPositionFor(currentDomIdx + 1) - snapPositionFor(currentDomIdx)) || 0;
      if (slideStep <= 0) slideStep = list.clientWidth || 400;
      var distanceThreshold = slideStep * 0.12;
      var velocityThreshold = 0.25;

      if (bestDomIdx === currentDomIdx && (Math.abs(posDelta) > distanceThreshold || Math.abs(dragVelocity) > velocityThreshold)) {
        var dirSwipe = posDelta < 0 ? 1 : (posDelta > 0 ? -1 : (dragVelocity < 0 ? 1 : -1));
        bestDomIdx = currentDomIdx + dirSwipe;
        if (!loop) {
          if (bestDomIdx < 0) bestDomIdx = wrapDrag ? totalSlides - 1 : 0;
          else if (bestDomIdx >= totalSlides) bestDomIdx = wrapDrag ? 0 : totalSlides - 1;
        }
      }

      if (loop) {
        var domDelta = bestDomIdx - currentDomIdx;
        if (domDelta === 0) { snapTo(logicalActive); return; }
        var dir = domDelta > 0 ? 1 : -1;
        snapTo(domToLogical(bestDomIdx), false, dir);
      } else {
        snapTo(domToLogical(bestDomIdx));
      }
    }

    function onPointerCancel(e) {
      if (!isDragging) return;
      if (e && e.pointerId !== undefined && e.pointerId !== pointerId) return;
      var moved = dragMoved;
      try { if (pointerId !== null && track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId); } catch (_) {}
      resetDragState();
      if (moved) snapTo(logicalActive);
    }

    if (watchDrag) {
      track.style.touchAction = 'pan-y pinch-zoom';
      track.addEventListener('pointerdown', onPointerDown);
      track.addEventListener('dragstart', function (e) { if (isDragging) e.preventDefault(); });
    }

    if (fade) {
      list.style.display = 'grid';
      list.style.gridTemplateColumns = '100%';
      list.style.gridAutoRows = 'minmax(0, 1fr)';
      list.style.position = 'relative';
      slides.forEach(function (s) {
        s.style.gridColumnStart = '1';
        s.style.gridRowStart = '1';
        s.style.width = '100%';
        s.style.height = '100%';
      });
      applyFadeState(true);
      applyActiveClass();
    } else {
      var currentDisplay = window.getComputedStyle(list).display;
      if (currentDisplay !== 'flex' && currentDisplay !== 'inline-flex') list.style.display = 'flex';
      if (!list.style.width) list.style.width = '100%';
      var currentOverflow = window.getComputedStyle(track).overflow;
      if (currentOverflow === 'visible') track.style.overflow = 'hidden';
      slides.forEach(function (s) { s.style.flexShrink = '0'; });
      measure();
      var initialDomIdx = logicalToDom(logicalActive);
      currentDomIdx = initialDomIdx;
      position = snapPositionFor(initialDomIdx);
      setTransform(true);
      applyActiveClass();
    }

    var autoplayApi = null;
    if (options.autoplay) {
      var ap = options.autoplay;
      var apDelay = ap.delay || 4000;
      var apTimer = null;
      var apPlaying = false;
      var apPaused = false;

      function apTick() {
        if (!apPlaying || apPaused) return;
        apTimer = setTimeout(function () {
          if (!apPlaying || apPaused) return;
          snapTo(logicalActive + 1);
          apTick();
        }, apDelay);
      }
      autoplayApi = {
        play: function () { if (apPlaying) return; apPlaying = true; apPaused = false; apTick(); },
        stop: function () { apPlaying = false; if (apTimer) { clearTimeout(apTimer); apTimer = null; } },
      };

      if (ap.stopOnMouseEnter) {
        rootEl.addEventListener('mouseenter', function () { apPaused = true; if (apTimer) clearTimeout(apTimer); });
        rootEl.addEventListener('mouseleave', function () { apPaused = false; if (apPlaying) apTick(); });
      }
      if (ap.stopOnInteraction !== false) {
        on('pointerDown', function () { apPaused = true; if (apTimer) clearTimeout(apTimer); });
        on('pointerUp', function () { apPaused = false; if (apPlaying) apTick(); });
      }
    }

    var resizeRO = null;
    if (typeof ResizeObserver !== 'undefined' && !fade) {
      var lastTrackW = trackW;
      resizeRO = new ResizeObserver(function () {
        var w = track.clientWidth;
        if (w === lastTrackW) return;
        lastTrackW = w;
        emit('resize');
      });
      resizeRO.observe(track);
    }

    setTimeout(function () { emit('init'); }, 0);

    return {
      scrollPrev: function () { snapTo(logicalActive - 1); },
      scrollNext: function () { snapTo(logicalActive + 1); },
      scrollTo: function (logicalIdx, jump) { snapTo(logicalIdx, !!jump); },
      selectedScrollSnap: function () { return logicalActive; },
      scrollSnapList: function () {
        var r = [];
        for (var i = 0; i < n; i++) r.push(i);
        return r;
      },
      on: on,
      reInit: function () {
        if (fade) { applyFadeState(true); return; }
        measure();
        var di = logicalToDom(logicalActive);
        currentDomIdx = di;
        position = snapPositionFor(di);
        setTransform(true);
      },
      destroy: function () {
        if (resizeRO) resizeRO.disconnect();
        if (animTimer) clearTimeout(animTimer);
        track.removeEventListener('pointerdown', onPointerDown);
        detachDocListeners();
        list.style.transition = '';
        list.style.transform = '';
        track.style.touchAction = '';
        list.querySelectorAll('.hf-clone').forEach(function (c) { c.remove(); });
        listeners = {};
      },
      plugins: function () { return autoplayApi ? { autoplay: autoplayApi } : {}; },
    };
  }

  window.HfCarousel = HfCarousel;
})();
